export class Ticket {
    ticket_id: number;
    titel: string;
    beschreibung: string;
    status_id: number;
    status: string;
    prioritaet: number;
    frontend_url: string;
    backend_url: string;
    files: File[] = [];
    erstellt: Date;
    erstellt_von: number;
    ersteller: string;
    kunde_id: number;
    kunde: string;
    vvvo: string;
    kommentare: TicketKommentar[] = [];
    tickettyp: string;
    tickettyp_id: number;
    dateien: TicketDateienListElement[] = [];
    zuweisungen: TicketZuweisung[] = [];
    prioritaet_bez: string;
    editiert: Date;
    zugewiesen: boolean;
    phito_hexid: string;
}

export class TicketKommentar {
    tk_id: number;
    ticket_id: number;
    erstellt_von: number;
    erstellt: string;
    ersteller: string;
    kommentar: string;
    oeffentlich = 1;
}

export class SupportedTypes {
    tickettyp_id: number;
    typ: string;
}

export class TicketPrioritaet {
    tp_id: number;
    bezeichnung: string;
    wert: number;
}

export class TicketDateienListElement {
    td_id: number;
    dateiname: string;
    ersteller: string;
    erstellt: Date;
    size: number;
    mimetype: string;
    erstellt_von: number;
}

export class TicketZuweisung {
    tz_id: number;
    benutzer_id: number;
    ticket_id: number;
    vorname: string;
    nachname: string;
    erstellt_von: number;
    erstellt: string;
}

export class TicketFarben {
    public static getColor(status_id: number): string {
        switch (status_id) {
            case 225:
                return '#C28FFBFF';
            case 226:
                return '#ee0707';
            case 227:
                return '#ff9100';
            case 228:
                return '#198f13';
            case 229:
                return '#39efef';
            case 230:
                return '#9e9e9e';
            default: // 224
                return '#000000';
        }
    }
}
